/**
 * Feature flags — habilitadas via variaveis de ambiente REACT_APP_*.
 *
 * Uso:
 *   import featureFlags from 'constants/featureFlags';
 *   {featureFlags.windx && <WindxMenuItem />}
 *
 * Para habilitar localmente, defina no .env:
 *   REACT_APP_WINDX_ENABLED=true
 */

const featureFlags = {
  windx: process.env.REACT_APP_WINDX_ENABLED === 'true',
  relatorios: process.env.REACT_APP_RELATORIOS_ENABLED === 'true',
  dessemAprovacao: process.env.REACT_APP_DESSEM_APROVACAO_ENABLED === 'true',
  // Flag geral da aprovação/publicação dos informes (DESSEM também a respeita).
  relatoriosAprovacao: process.env.REACT_APP_RELATORIOS_APROVACAO_ENABLED === 'true',
  // Nova aba Meus Estudos do Flux Personalizado, só no desktop (#1983). Fica fora do .env
  // versionado e do Netlify até a virada; com ela desligada, a lista legada segue igual.
  fluxMeusEstudosV2: process.env.REACT_APP_FLUX_MEUS_ESTUDOS_V2_ENABLED === 'true',
  // Nova aba Meus Estudos do Flux Upload, só no desktop (backend #80). Fora do .env versionado e do
  // Netlify até o backend estar em produção; com ela desligada, a lista legada segue igual.
  fluxUploadMeusEstudosV2: process.env.REACT_APP_FLUX_UPLOAD_MEUS_ESTUDOS_V2_ENABLED === 'true',
  // Seletor de empresa em Meus Arquivos, só para admin (backend MR !338). Fora do .env versionado
  // até o backend estar em produção; com ela desligada, a tela segue igual para todo mundo.
  meusArquivosEmpresa: process.env.REACT_APP_MEUS_ARQUIVOS_EMPRESA_ENABLED === 'true',
};

export default featureFlags;
